<template>
  <UiSelect
    class="ui-async-select"
    :value="value"
    :resolve-request="selectResolveRequest"
    :options="fetchSelectOptions"
    :disabled="disabled"
    :error="error"
    searchable
    clearable
    :close-on-select="closeOnSelect"
    :preload-immediately="preloadImmediately"
    :min-search-length="minSearchLength"
    @input="$emit('input', $event)"
    @close="$emit('blur')"
    @open="$emit('focus')"
  />
</template>

<script>
import Vue from 'vue'
import UiSelect from '@shared/ui/public/forms/fields/UiSelect.vue'

export default {
  name: 'UiAsyncSelect',
  emits: ['input', 'focus', 'blur'],
  model: {
    prop: 'value',
    event: 'input',
  },
  components: {
    UiSelect,
  },
  props: {
    value: {
      type: [Array, Object, String, Number],
      default: null,
    },
    fieldId: {
      type: Number,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    searchUrl: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    closeOnSelect: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    preloadImmediately: {
      type: Boolean,
      default: true,
    },
    minSearchLength: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    async fetchSelectOptions(params = {}) {
      try {
        const response = await Vue.http.get(this.searchUrl, { params })
        return await response.json()
      } catch (e) {
        console.error(e)
        return null
      }
    },
    selectResolveRequest(params) {
      return { entityId: this.entityId, fieldId: this.fieldId, ...params }
    },
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/UiAsyncSelect.vue